import React, { useState, useEffect } from "react";
import "./Prioritycolpagesss.css";
import { getCriticalAlerts } from "../../../api/collectorApi";
import { useTranslation } from "react-i18next";
export default function Prioritycolpagesss() {
  const [priorityCards, setPriorityCards] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
const { t, i18n } = useTranslation();
  const nextCard = () => {
    setCurrentIndex((prev) =>
      priorityCards.length > 0 ? (prev + 1) % priorityCards.length : 0
    );
  };

  useEffect(() => {
    const loadCriticalAlerts = async () => {
      try {
        const alerts = await getCriticalAlerts();

        const transformedCards = alerts.map((item) => ({
          category: item.category || "N/A",
          complaintNo: item.grievanceId,
          citizenName: item.citizen.name,
          title: item.description,
          officer: item.assignedOfficer?.name || "Not Assigned",
          location: item.assignedOfficer?.department || "Unknown",
          date: new Date(item.createdAt).toLocaleDateString("en-GB"),
          resolvedDate: item.estimatedResolutionDate
  ? new Date(item.estimatedResolutionDate).toLocaleDateString("en-GB")
  : "Pending",
          pendingDays: Math.max(
            0,
            Math.ceil(
              (new Date() - new Date(item.createdAt)) /
                (1000 * 60 * 60 * 24)
            )
          ),
          status: item.status,
        }));

        setPriorityCards(transformedCards);
      } catch (err) {
        console.log("Error loading Critical Alerts:", err);
      }
    };

    loadCriticalAlerts();
  }, []);

  useEffect(() => {
    if (!showPopup && priorityCards.length > 0) {
      const interval = setInterval(nextCard, 2000);
      return () => clearInterval(interval);
    }
  }, [showPopup, priorityCards]);

  return (
    <div className="Prioritycolpagesss">
      <div className="priorityHeaderRow">
       <h2 className="priorityHeading">
  {t("priority.title")}
</h2>
        <button className="viewAllBtn" onClick={() => setShowPopup(true)}>
         {t("priority.viewAll")}
        </button>
      </div>

      {/* Sliding Card */}
      {priorityCards.length > 0 ? (
        <div className="priorityCardWrapper">
          <div className="priorityCard blink">
            <div className="priorityRibbon">
              {priorityCards[currentIndex].category}
            </div>

            <div className="priorityContent">
              <p>
               <strong>{t("priority.complaintNo")}:</strong>
                {priorityCards[currentIndex].complaintNo}
              </p>
              <p>
                <strong>{t("priority.complaintBy")}:</strong>{" "}
                {priorityCards[currentIndex].citizenName}
              </p>
              <p>
                <strong>{t("priority.title")}:</strong> {priorityCards[currentIndex].title}
              </p>
              <p>
                <strong>{t("priority.officerName")}:</strong>{" "}
                {priorityCards[currentIndex].officer}
              </p>
              <p>
                <strong>{t("priority.location")}:</strong>{" "}
                {priorityCards[currentIndex].location}
              </p>
              <p>
                <strong>{t("priority.date")}:</strong> {priorityCards[currentIndex].date}
              </p>
              <p>
                <strong>{t("priority.resolvedDate")}:</strong>{" "}
                {priorityCards[currentIndex].resolvedDate}
              </p>
              <p>
                <strong>{t("priority.pendingDays")}:</strong>{" "}
                {priorityCards[currentIndex].pendingDays}
              </p>
            </div>
          </div>
        </div>
      ) : (
        // <p className="noDataText">No Priority Alerts Found</p>
        <div className="priorityCardWrapper">
          <div className="priorityCard blink">
            <div className="priorityContent">
          <p className="noDataText">{t("priority.noData")}</p></div>

            </div>
          </div>
      )}

      {/* Popup */}
      {showPopup && (
        <div className="priorityPopupOverlay">
          <div className="priorityPopupBox">
            <div className="priorityPopupHeader">
              <h2>{t("priority.complaintDetails")}</h2>
              <button
                className="closePopupBtn"
                onClick={() => setShowPopup(false)}
              >
               {t("common.close")}
              </button>
            </div>

            <div className="priorityPopupBody">
              

              <div className="priorityAllGrid">
                {priorityCards.map((card, index) => {
                  const isResolved = card.status === "resolved";

                  return (
                    <div key={index} className="priorityCard small">
                      <div className="priorityRowTop">
                        <span className="priorityComplaintId">
                          {card.complaintNo}
                        </span>
                        <br/> <br/>
                        <span
                          className={
                            "priorityStatusChip " +
                            (isResolved
                              ? "priorityStatusResolved"
                              : "priorityStatusInvestigation")
                          }
                        >
                        {isResolved
  ? t("priority.resolved")
  : t("priority.underInvestigation")}
                        </span>
                      </div>

                      <div className="priorityRowBody">
                        <p className="priorityType"><b>{t("priority.complaintLabel")}</b>{card.title}</p>
                          <p className="priorityType"><b>{t("priority.complaintBy")}:</b> {card.citizenName}</p>
                        <p className="priorityLocation"><b>{t("priority.department")}:</b> {card.location}</p>
                        <p className="priorityDate"><b>{t("priority.date")}:</b> {card.date}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
